import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var align_center_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M7.5 5.5h9V4h-9v1.5Zm-3.5 7h16V11H4v1.5Zm3.5 7h9V18h-9v1.5Z" }) });
export {
  align_center_default as default
};
//# sourceMappingURL=align-center.js.map
